import axios from "axios";

const getDefaultState = () => {
  return {
    toast: {
      def_content: "Content",
      def_confirm_text: "Are you sure?",
      def_settings: {
        title: "Notification",
        variant: "info",
        noAutoHide: false,
        solid: true,
        appendToast: true,
        toaster: "b-toaster-bottom-left"
      },
      def_error_settings: {
        title: "Error",
        variant: "danger",
        noAutoHide: true,
        appendToast: true,
        toaster: "b-toaster-bottom-left"
      }
    },
    agent_options: []
  };
};

const state = getDefaultState();

const actions = {
  clearAgentOptions({ state }) {
    state.agent_options = [];
  },
  makeToast({ state }, payload) {
    let content = JSON.parse(JSON.stringify(state.toast.def_content));
    let settings = JSON.parse(JSON.stringify(state.toast.def_settings));

    if (payload.content != null) content = payload.content;
    if (payload.title != null) settings.title = payload.title;
    if (payload.variant != null) settings.variant = payload.variant;
    if (payload.noAutoHide != null) settings.noAutoHide = payload.noAutoHide;

    payload.this_ref.$root.$bvToast.toast(content, settings);
  },
  makeErrorToast({ state }, payload) {
    let content = JSON.parse(JSON.stringify(state.toast.def_content));
    let settings = JSON.parse(JSON.stringify(state.toast.def_error_settings));

    if (payload.content != null) content = payload.content;
    if (payload.title != null) settings.title = payload.title;

    payload.this_ref.$root.$bvToast.toast(content, settings);
    console.error(content);
  },
  mutationReturnData({ state, commit, rootGetters, dispatch }, payload) {

    return new Promise((resolve, reject) => {
      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            res.data.errors.forEach(e => {
              // Check for timeout error to logout
              if (e.message == "Login timeout, logout and login again.") {
                dispatch("auth/logOut", null, { root: true });
                resolve(false);
              }

              dispatch("makeErrorToast", {
                this_ref: payload.this_ref,
                content: e.message != null ? e.message : "Something went wrong."
              });
            });
            resolve(false);
          } else {
            resolve(res.data.data);
          }
        })
        .catch(err => {
          dispatch("makeErrorToast", {
            this_ref: payload.this_ref,
            content: err != null ? err : "Something went wrong."
          });
          resolve(false);
        });
    });
  },
  simpleMutation({ state, commit, rootGetters, dispatch }, payload) {
    /*
    import { mapActions } from "vuex";
      // Dont forget about "res:"
      ...mapActions("axios_mod", ["simpleMutation"])

      let data = {
        query: `
          mutation {
            res: updateInquiryAgent (
              inquiry_id: ${parseInt(this.$route.params.id)},
              new_agent_id: ${parseInt(this.new_agent_id)}
            )
          }
        `
      };

      OR

      let data = {
        query: `
          mutation CustomerUpdateNotes($customer_id: ID!, $new_notes: String!) {
            res: CustomerUpdateNotes (customer_id: $customer_id, new_notes: $new_notes)
          }
        `,
        variables: {
          customer_id: parseInt(this.$route.params.id),
          new_notes: this.notes
        }
      };

      this.simpleMutation({data, this_ref: this}).then(() => {
        this.new_agent_id = 0;
        this.close();
      });
    */
    return new Promise((resolve, reject) => {
      let confirm_text = state.toast.def_confirm_text;
      if (payload.confirm_text != null) {
        confirm_text = payload.confirm_text;
      }

      let skip_confirm = payload.skip_confirm != null && payload.skip_confirm;

      if (skip_confirm || confirm(confirm_text)) {
        commit("setShowLoadingModal", true, { root: true });

        axios
          .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
          .then(res => {
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              res.data.errors.forEach(e => {
                // Check for timeout error to logout
                if (e.message == "Login timeout, logout and login again.") {
                  dispatch("auth/logOut", null, { root: true });
                  resolve(false);
                } else {
                  dispatch("makeErrorToast", {
                    this_ref: payload.this_ref,
                    content:
                      e.message != null ? e.message : "Something went wrong."
                  });
                }
              });
            } else {
              dispatch("makeToast", {
                this_ref: payload.this_ref,
                content: res.data.data.res
              });
            }
          })
          .catch(err => {
            dispatch("makeErrorToast", {
              this_ref: payload.this_ref,
              content: err != null ? err : "Something went wrong."
            });
          })
          .then(() => {
            commit("setShowLoadingModal", false, { root: true });
            resolve(true);
          });
      }
    });
  },
  simpleFetch({ commit, rootGetters, dispatch }, payload) {
    /*
    ...mapActions("axios_mod", ["simpleFetch"]),


    const data = {
      query: `
        query  {
          allAgents {
            full_name
            id
          }
        }
      `
    };
    this.setShowLoadingModal(true);
    this.simpleFetch({data, this_ref: this}).then((res) => {
      if (res) {
        this.agentOptions.push(
          ...res.allAgents.map(agent => {
            return {
              value: agent.id,
              text: agent.full_name
            };
          })
        );
      }
    }).finally(()=>{
      this.setShowLoadingModal(false)
    });
  */
    return new Promise((resolve, reject) => {
      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            res.data.errors.forEach(e => {
              // Check for timeout error to logout
              if (e.message == "Login timeout, logout and login again.") {
                dispatch("auth/logOut", null, { root: true });
                resolve(false);
              }

              dispatch("makeErrorToast", {
                this_ref: payload.this_ref,
                content: e.message != null ? e.message : "Something went wrong."
              });
            });
            resolve(false);
          } else {
            resolve(res.data.data);
          }
        })
        .catch(err => {
          dispatch("makeErrorToast", {
            this_ref: payload.this_ref,
            content: err != null ? err : "Something went wrong."
          });
          resolve(false);
        });
    });
  },
  fetchAgents({ state, commit, dispatch, rootGetters }, payload = {}) {
    const storedAgents = state.agent_options;
    const hasStoredAgents = Array.isArray(storedAgents) && storedAgents.length > 0;
    const forceRefresh = payload.force_refresh === true || payload.forceRefresh === true;

    if (hasStoredAgents && !forceRefresh) {
      return Promise.resolve(storedAgents);
    }

    const data = {
      query: `
        query {
          allAgents {
            value: id
            text: full_name
            active: is_visible
          }
        }
      `
    };

    return new Promise((resolve, reject) => {
      commit("setShowLoadingModal", true, { root: true });

      axios
        .post(rootGetters.getGraphQlUrl, data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            res.data.errors.forEach(e => {
              if (e.message == "Login timeout, logout and login again.") {
                dispatch("auth/logOut", null, { root: true });
                resolve(false);
              }

              dispatch("makeErrorToast", {
                this_ref: payload.this_ref,
                content: e.message != null ? e.message : "Something went wrong."
              });
            });
            resolve(false);
          } else {
            const agents = (res.data.data.allAgents || []).filter(agent => {
              return agent.active === true || agent.active === "true" || agent.active === 1;
            });

            state.agent_options = agents;

            resolve(agents);
          }
        })
        .catch(err => {
          dispatch("makeErrorToast", {
            this_ref: payload.this_ref,
            content: err != null ? err : "Something went wrong."
          });
          resolve(false);
        })
        .then(() => {
          commit("setShowLoadingModal", false, { root: true });
        });
    });
  },
  simpleWebAppMutation({ commit, rootGetters, dispatch }, payload) {
    /*
      // Dont forget about "res:"
      ...mapActions("axios_mod", ["simpleWebAppMutation"])

      let data = {
        query: `
          mutation {
            res: ImportToolImportUsers (
              importCsv: ${JSON.stringify(data64)},
              pairs: ${JSON.stringify(this.pairs)}
            ) { message }
          }
        `
      };

      this.simpleWebAppMutation({data, this_ref: this}).then(() => {
        //this.new_agent_id = 0;
        //this.close();
      });
    */
    return new Promise((resolve, reject) => {
      if (confirm("Are you sure?")) {
        commit("setShowLoadingModal", true, { root: true });

        axios
          .post(rootGetters.getWebAppGraphQlUrl, payload.data, {
            headers: {
              Authorization: `Token token=${rootGetters.getUserToken}`
            }
          })
          .then(res => {
            //console.log(res)
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              res.data.errors.forEach(e => {
                dispatch("makeErrorToast", {
                  this_ref: payload.this_ref,
                  content:
                    e.message != null ? e.message : "Something went wrong."
                });
              });
            } else {
              dispatch("makeToast", {
                this_ref: payload.this_ref,
                content: res.data.data.res.message
              });
            }
          })
          .catch(err => {
            dispatch("makeErrorToast", {
              this_ref: payload.this_ref,
              content: err != null ? err : "Something went wrong."
            });
          })
          .then(() => {
            commit("setShowLoadingModal", false, { root: true });
            resolve();
          });
      }
    });
  },
  simpleWebAppFetch({ commit, rootGetters, dispatch }, payload) {
    /*
    ...mapActions("axios_mod", ["simpleFetch"]),


    const data = {
      query: `
        query  {
          allAgents {
            full_name
            id
          }
        }
      `
    };
    this.setShowLoadingModal(true);
    this.simpleFetch({data, this_ref: this}).then((res) => {
      if (res) {
        this.agentOptions.push(
          ...res.allAgents.map(agent => {
            return {
              value: agent.id,
              text: agent.full_name
            };
          })
        );
      }
    }).finally(()=>{
      this.setShowLoadingModal(false)
    });
  */
    return new Promise((resolve, reject) => {
      axios
        .post(rootGetters.getWebAppGraphQlUrl, payload.data, {
          headers: {
            Authorization: `Token token=${rootGetters.getUserToken}`
          }
        })
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            res.data.errors.forEach(e => {
              dispatch("makeErrorToast", {
                this_ref: payload.this_ref,
                content: e.message != null ? e.message : "Something went wrong."
              });
            });
            resolve(false);
          } else {
            resolve(res.data.data);
          }
        })
        .catch(err => {
          dispatch("makeErrorToast", {
            this_ref: payload.this_ref,
            content: err != null ? err : "Something went wrong."
          });
          resolve(false);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  actions
};
